import React from 'react';
import { Card, CardContent, CardHeader } from '../components/ui/card';
import SEOHead from '../components/SEOHead';
import { siteContent } from '../data/mockData';

const LegalPage = ({ type }) => {
  const content = siteContent.en?.legal?.[type] || siteContent.en.legal[type];
  
  // SEO configuration for different legal page types
  const seoConfig = {
    privacy: {
      title: "Privacy Policy - MedQuore | Medical Device Quality & Compliance",
      description: "MedQuore's privacy policy for our medical device quality and compliance consulting services. Learn how we protect your data and privacy.",
      keywords: "privacy policy, data protection, medquore privacy, medical device consulting privacy",
      canonical: "https://medquore.com/privacy"
    },
    terms: {
      title: "Terms of Service - MedQuore | Medical Device Quality & Compliance",
      description: "Terms of service for MedQuore's medical device quality and regulatory compliance consulting services. Professional service agreements.",
      keywords: "terms of service, service agreement, medquore terms, medical device consulting terms",
      canonical: "https://medquore.com/terms"
    },
    cookies: {
      title: "Cookie Policy - MedQuore | Medical Device Quality & Compliance",
      description: "MedQuore's cookie policy explaining how we use cookies on our medical device quality and compliance consulting website.",
      keywords: "cookie policy, website cookies, medquore cookies, medical device consulting cookies",
      canonical: "https://medquore.com/cookies"
    }
  };

  const currentSEO = seoConfig[type] || {
    title: "Legal Information - MedQuore",
    description: "Legal information for MedQuore medical device quality and compliance services.",
    keywords: "legal information, medquore legal",
    canonical: `https://medquore.com/${type}`
  };
  
  if (!content) {
    return (
      <div className="py-20 lg:py-32 bg-white">
        <SEOHead {...currentSEO} />
        <div className="container mx-auto px-4 lg:px-6">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-[#011431] mb-4">Page Not Found</h1>
            <p className="text-gray-600">The requested legal page could not be found.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="py-20 lg:py-32 bg-white min-h-screen">
      <SEOHead {...currentSEO} />
      <div className="container mx-auto px-4 lg:px-6 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-3xl lg:text-4xl font-bold text-[#011431] mb-4">
            {content.title}
          </h1>
          <p className="text-gray-600">
            Last Updated: {content.lastUpdated}
          </p>
        </div>

        {/* Content Sections */}
        <div className="space-y-8">
          {content.sections.map((section, index) => (
            <Card key={index} className="shadow-sm border-l-4 border-l-[#c41927]">
              <CardHeader className="pb-4">
                <h2 className="text-xl font-bold text-[#011431]">
                  {section.title}
                </h2>
              </CardHeader>
              <CardContent>
                <p className="text-gray-700 leading-relaxed">
                  {section.content}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Footer Note */}
        <div className="mt-12 p-6 bg-[#f0f0e8] rounded-lg text-center">
          <p className="text-sm text-gray-600">
            If you have any questions about this {content.title.toLowerCase()}, 
            please contact us at <a href="mailto:contact@medquore.com" className="text-[#c41927] hover:underline">contact@medquore.com</a>
          </p>
        </div>

        {/* Back to Home */}
        <div className="text-center mt-8">
          <button
            onClick={() => window.history.back()}
            className="text-[#c41927] hover:text-[#a01520] font-medium transition-colors"
          >
            ← Back to Previous Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;